module.exports = __webpack_public_path__ + "img/expired.ea9f3152.png";